'use client';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
import {
  EquipmentActionIcon,
  EquipmentActionName
} from '@cat-ecom/pcc-components';

export interface IconCardProps {
  id: string;
  icon: ReactNode;
  label: string;
  classname?: string;
}

const EquipmentActionsIconCard = ({
  id,
  icon,
  label,
  classname
}: Readonly<IconCardProps>) => {
  const t = useTranslations();
  return (
    <>
      <EquipmentActionIcon name={id} isIconExist={true}>
        {icon}
      </EquipmentActionIcon>
      <EquipmentActionName>
        <span className={classname}>{t(label)}</span>
      </EquipmentActionName>
    </>
  );
};

export default EquipmentActionsIconCard;
